import { pageUrl, sectionHomeUrl } from "../../utils/urls";

import { t } from "i18n/i18n";
import { SquareButton } from "mds/components/buttons/SquareButton";
import { Link, useQueryParamsManager } from "utils/routing";

const makeRedirectURL = (sectionId: string, pageId: string) => {
  // For now, we just handle page redirects for LTI endpoint
  if (pageId) {
    return pageUrl(sectionId, pageId);
  }
  return sectionHomeUrl(sectionId);
};

export default function Page() {
  const { getQueryParam } = useQueryParamsManager();
  const sectionId = getQueryParam("sectionId") || "";
  const pageId = getQueryParam("pageId") || "";
  const url = makeRedirectURL(sectionId, pageId);

  return (
    <div className="m-5">
      <SquareButton as={Link} kind="accent" size="m" target="_blank" to={url}>
        {t("common.new_tab")}
      </SquareButton>
    </div>
  );
}
